module.exports = __webpack_public_path__ + "static/media/ico_sbi_512.c5e67d69.png";